import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const testimonials = [
  {
    quote:
      "Ich war skeptisch. Mein erster Kunde war ein Friseursalon — 1.200€ für eine Website, die ich in 90 Minuten gebaut hab.",
    name: "Jonas M.",
    meta: "24 · Student · Köln",
    avatar: "/avatars/jonas.jpg",
  },
  {
    quote:
      "Kein Tech-Hintergrund, trotzdem 1.800€ mit meinem ersten Restaurantkunden in Woche 2. Ich bin immer noch baff.",
    name: "Sarah K.",
    meta: "31 · Quereinsteigerin · Hamburg",
    avatar: "/avatars/sarah.jpg",
  },
  {
    quote:
      "Die Methode hat meine Arbeitszeit halbiert und meinen Umsatz verdoppelt. Letzten Monat 4.200€ mit drei Projekten.",
    name: "Tim R.",
    meta: "27 · Freelancer · München",
    avatar: "/avatars/tim.jpg",
  },
];

export default function TestimonialsSection() {
  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="testimonials-section"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-20"
        >
          <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
            Stimmen
          </span>
          <h2
            className="text-4xl sm:text-5xl font-black text-[#F5F5F7] mt-4 tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Echte Ergebnisse.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease, delay: i * 0.1 }}
              whileHover={{ y: -6, transition: { duration: 0.3, ease } }}
              className="flex flex-col p-8 bg-[#111111] rounded-2xl"
              style={{ border: "1px solid rgba(255,255,255,0.05)" }}
              data-testid={`testimonial-card-${i}`}
            >
              {/* Quote marks */}
              <span className="text-[#C9A84C]/30 text-5xl font-serif leading-none mb-4 select-none">"</span>
              <p className="text-[#F5F5F7] text-base leading-relaxed flex-1 mb-8">
                {t.quote}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  style={{ border: "2px solid rgba(201,168,76,0.25)" }}
                />
                <div>
                  <p className="text-[#F5F5F7] font-semibold text-sm">{t.name}</p>
                  <p className="text-[#86868b] text-xs">{t.meta}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
